import WeblGLDestructible from './WebGLDestructible';
import IWebGLPreloadable from './IWebGLPreloadable';

export default class WebGLPreLoader extends WeblGLDestructible {
  private loadsRequested: IWebGLPreloadable[] = [];
  private loadsCompleted: number = 0;
  private progress: number = 0;
  private _loading: boolean = false;

  private callback: any;
  private progressCallBack: ((percentage: number) => void) | undefined = undefined;
  private callbackPerPreloadable: Array<(() => void) | undefined> = [];

  public add<T extends IWebGLPreloadable>(preloadable: T, callback: (() => void) | undefined = undefined): T {
    const index = this.loadsRequested.push(preloadable) - 1;
    this.callbackPerPreloadable.push(callback);

    if (this.loading) {
      // add preloadable while preloader is loading, so directly start
      // this download
      this.startLoader(index);
    }
    return preloadable;
  }

  public load(callback: (() => void) | undefined = undefined, progressCallBack: ((percentage: number) => void) | undefined = undefined): void {
    this.callback = callback;
    this.progressCallBack = progressCallBack;
    this.loadAll();
  }

  public get loading(): boolean {
    return this._loading;
  }

  public loadAll() {
    if (this.loadsRequested.length === 0) {
      this.loadDoneCallback();
      return;
    }

    this._loading = true;

    for (let i = 0; i < this.loadsRequested.length; i++) {
      this.startLoader(i);
    }
  }

  public setCallbackForPreloadable(preloadable: IWebGLPreloadable, callback: (() => void) | undefined = undefined) {
    this.callbackPerPreloadable[this.getIndexOfPreloadable(preloadable)] = callback;
  }

  private getIndexOfPreloadable(preloadable: IWebGLPreloadable): number {
    return this.loadsRequested.indexOf(preloadable);
  }

  private startLoader(index: number) {
    this.loadsRequested[index].load(() => {
      const callback = this.callbackPerPreloadable[index];
      if (callback) {
        callback();
      }
      this.loadDoneCallback();
    });
  }

  private loadDoneCallback() {
    this.loadsCompleted++;

    // (c) Windows load progress
    this.progress += (1 - this.progress) / (1 + this.loadsRequested.length - this.loadsCompleted);

    if (this.progressCallBack) {
      if (this.loadsRequested.length) {
        this.progressCallBack.call(this, this.progress);
      } else {
        this.progressCallBack.call(this, 1);
      }
    }

    // check if all requested loads are loaded
    if (this.loadsCompleted >= this.loadsRequested.length) {
      this._loading = false;

      if (this.callback) {
        this.callback.call(this);
        this.callback = null;
      }
    }
  }

  destruct() {
    this.callback = undefined;
    super.destruct();
  }
}
